import type { GetDisclosureTitleDTO } from '@/domains/disclosure/repository/disclosure-repository';
import type { GetDisclosureTitleRequest } from '@/domains/disclosure/types';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetDisclosureTitle } from '@/infrastructure/api-functions/core-drafting-api/get-disclosure-title-api';

@injectable()
export class GetDisclosureTitleDTOImpl implements GetDisclosureTitleDTO {
    constructor(
        @inject(GetDisclosureTitle)
        private readonly _getDisclosureTitleApi: GetDisclosureTitle,
    ) { }

    async fetch(value: GetDisclosureTitleRequest): Promise<string> {
        const params = {
            task_id: value.taskId,
            current_step: value.currentStep,
        };

        return await this._getDisclosureTitleApi.getDisclosureTitle(params);
    }
}
